// Tezgâhtaki eşyaların yerinden bağımsız anahtarı: "other:19*1+pot:1*1".
// Sunucudaki craft.CellComboKey ile birebir aynı sonucu vermelidir (backend/craft/catalog.go);
// iki tarafın aynı test vektörleri backend/craft/craft_test.go > TestComboKeyVectors içinde.
export const craftComboKey = (cells) => {
  const counts = new Map();
  (cells || []).forEach((key) => {
    if (key) counts.set(key, (counts.get(key) || 0) + 1);
  });
  return [...counts.keys()]
    .sort()
    .map((key) => `${key}*${counts.get(key)}`)
    .join('+');
};

// Hücrelerdeki eşyaları sayar ("pot:1" -> 2).
export const countCraftCells = (cells) => {
  const counts = new Map();
  (cells || []).forEach((key) => {
    if (key) counts.set(key, (counts.get(key) || 0) + 1);
  });
  return counts;
};

// Tezgâhtaki malzeme kümesinin anahtarı: "other:19+pot:1". Tarifi hangi eşyaların konduğu
// belirler, adetler kaç kez üretileceğini. Sunucudaki craft.SetKey ile birebir aynı sonucu verir
// (backend/craft/craft_test.go > TestSetKeyVectors).
export const craftSetKey = (keys) => [...new Set((keys || []).filter(Boolean))].sort().join('+');
